import React from "react";

const ContentRowItem = ({title,children}) => {
	return (
		<div className="w-full rounded-xl bg-white overflow-hidden shadow-sm">
			{title && 
			<p className='w-full text-xs tracking-wider text-center pt-2 font-semibold text-[rgb(68,71,70)] wrap-break-word overflow-hidden uppercase'>
				{title}
			</p>}
			<div className='w-full'>
				{children}
			</div>
		</div>
	);
};

export default ContentRowItem;
